import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-housekeeping',
  templateUrl: '../views/housekeeping.component.html',
  styleUrls: ['../css/housekeeping.component.css']
})
export class HousekeepingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/components/housekeeping.component.ts